export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "虚空漫画网收录哪些类型的漫画？",
    a: "本站专注于异世界、穿越、奇幻、脑洞、玄幻五类题材，兼收热血、搞笑、美食、机甲、修仙等热门细分类型，为你提供一站式的轻小说改编与国漫佳作合集。",
  },
  {
    q: "热门榜单多久更新一次？",
    a: "热门榜单与「今日更新」板块每日更新一次，综合参考漫画的阅读热度、评分与近七日人气增速，让你第一时间掌握最值得入坑的新作。",
  },
  {
    q: "站内漫画是否需要付费？",
    a: "本站免费提供海量漫画的在线阅读与章节更新，完本推荐栏目的作品可全程免费追完。部分版权内容以试读形式呈现，请留意各作品的页面说明。",
  },
  {
    q: "为什么有些漫画显示「试读」？",
    a: "受版权方要求，少数热门作品提供前若干话免费试读，完整内容请在正版平台支持原作者。我们始终倡导尊重创作、支持正版。",
  },
  {
    q: "如何收藏或加入追更？",
    a: "打开任意漫画详情页，点击「加入追更」按钮即可收藏，之后可在我喜欢与追更记录中查看最新章节动态。目前无需注册即可使用该功能。",
  },
  {
    q: "漫画页面的评分是怎么来的？",
    a: "评分为站内读者的综合评分，综合阅读体验、剧情与画工三个维度，保留一位小数。你的每一次评分都会影响作品的热度权重。",
  },
  {
    q: "发现作品信息有误或想要推荐新作？",
    a: "欢迎通过「联系我们」页面向我们反馈，也可以在每部作品详情页提交纠错与推荐。我们会尽快核实并更新，感谢每一位热心读者。",
  },
];